/** Any size works; a round one keeps the ratio readable. */
const PROBE_FONT_SIZE_PX = 100;

/**
 * Android's system font size (Settings → Display → Font size) as the page sees it.
 *
 * The WebView applies that setting to every computed font size — an element set to 100px computes to 150px at 1.5 —
 * so a probe's computed size is the setting itself. Browsers' own zoom and default-font settings leave an explicit
 * px size alone, so elsewhere this reads 1.
 */
export const measureTextScale = (): number => {
	const probe = document.createElement("span");
	probe.style.fontSize = `${PROBE_FONT_SIZE_PX}px`;
	document.body.appendChild(probe);
	const scale = Number.parseFloat(getComputedStyle(probe).fontSize) / PROBE_FONT_SIZE_PX;
	probe.remove();
	return scale;
};
